import { Dispatch, SetStateAction } from 'react';
import {
  Box,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  type Theme,
} from '@mui/material';
import { Icon24UtilityChevron } from '@care/react-icons';
import { StepperInput } from '@care/react-component-lib';

interface NumberOfChildrenSectionProps {
  numberOfChildren: number;
  setNumberOfChildren: Dispatch<SetStateAction<number>>;
}

export const NumberOfChildren = ({
  numberOfChildren,
  setNumberOfChildren,
}: NumberOfChildrenSectionProps) => {
  const isExtraSmallOrSmallViewport = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const isMediumOrLargerViewport = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const childOrChildren = numberOfChildren < 2 ? 'Child' : 'Children';

  return (
    <Box component="section" mb={2}>
      {isExtraSmallOrSmallViewport && (
        <>
          <Typography variant="h3">Number of children</Typography>
          <StepperInput
            name="number-of-children-stepper-input"
            stepperLabel={childOrChildren}
            initialVal={numberOfChildren}
            min={1}
            max={5}
            layout="horizontal"
            maxInputSuffix
            onChange={setNumberOfChildren}
          />
        </>
      )}
      {isMediumOrLargerViewport && (
        <Accordion elevation={0} defaultExpanded>
          <AccordionSummary
            expandIcon={<Icon24UtilityChevron />}
            sx={{ padding: 0, width: 'fit-content' }}>
            <Typography variant="h3" mr={1}>
              Number of children
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={(theme) => ({
              padding: theme.spacing(0, 0, 0, 0.5),
            })}>
            <StepperInput
              name="number-of-children-stepper-input"
              stepperLabel={childOrChildren}
              initialVal={numberOfChildren}
              min={1}
              max={5}
              layout="horizontal"
              maxInputSuffix
              onChange={setNumberOfChildren}
              sx={{
                display: 'flex',
                '& label': {
                  mr: 10,
                },
              }}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};
